import moment from 'moment';
import styled from 'styled-components';
import MessageContentColumn from './MessageTableContentColumn';

export const reservedMessageColumns = [
    {
        title: 'No',
        dataIndex: 'key',
        key: 'key',
        width: 56,
        render: (key, record, index) => (
            <CustomColumn>{index + 1}</CustomColumn>
        ),
    },
    //   {
    //     title: "타입",
    //     dataIndex: "type",
    //     key: "type",
    //     width: 128,
    //     render: (key, record, index) => <CustomColumn>{record.TYPE}</CustomColumn>,
    //   },
    {
        title: '발신번호',
        dataIndex: 'caller',
        key: 'caller',
        width: 196,
        render: (_, record) => {
            if (record.job_id) {
                return (
                    <CustomColumn>
                        {record?.callback_num?.replace(
                            /^(\d{3})(\d{4})(\d{4})$/,
                            '$1-$2-$3',
                        )}
                    </CustomColumn>
                );
            }
        },
    },
    {
        title: '수신번호',
        dataIndex: 'receiver',
        key: 'receiver',
        width: 196,
        render: (_, record, idx) => {
            if (record.job_id) {
                return (
                    <CustomColumn>
                        {record?.rcpt_data?.replace(
                            /^(\d{3})(\d{4})(\d{4})$/,
                            '$1-$2-$3',
                        )}
                    </CustomColumn>
                );
            }
        },
    },
    {
        title: '예약일시',
        dataIndex: 'date',
        key: 'date',
        width: 196,
        render: (_, record) => {
            // 메세지 내역(구)
            if (record.RSLTDATE || record.TR_RSLTDATE) {
                return (
                    <CustomColumn>
                        {record.RSLTDATE
                            ? record.RSLTDATE
                            : record.TR_RSLTDATE
                            ? record.TR_RSLTDATE
                            : null}
                    </CustomColumn>
                );
            }
            // 메세지 내역(신)
            if (record.schedule_time) {
                // 예약 내역은 전달할 시간을 표시
                return (
                    <CustomColumn>
                        {moment(record.schedule_time).format(
                            'YYYY-MM-DD HH:mm:ss',
                        )}
                    </CustomColumn>
                );
            }

            // 예약 / 발송 내역이 나뉘어져 있어서 필요없는 코드
            // if (record.is_reserved) {
            //     // 예약 내역은 전달할 시간을 표시
            //     return (
            //         <CustomColumn>
            //             {moment(record.schedule_time).format(
            //                 'YYYY-MM-DD HH:mm:ss',
            //             )}
            //         </CustomColumn>
            //     );
            // } else {
            //     // 발송 내역은 실제 전달 된 시간을 표시
            //     return (
            //         <CustomColumn>
            //             {moment(record.delivery_time).format(
            //                 'YYYY-MM-DD HH:mm:ss',
            //             )}
            //         </CustomColumn>
            //     );
            // }
        },
    },
    {
        title: '상태',
        dataIndex: 'result',
        key: 'result',
        width: 132,
        render: (_, record) => {
            // 발송 / 예약 내역이 나뉘어져 있어서 필요없는 코드 (기존 발송 내역 코드)
            // if (
            //     !record.is_reserved &&
            //     record.result !== null &&
            //     record.result === 0
            // ) {
            //     return <CustomColumn>{'성공'}</CustomColumn>;
            // }

            // if (
            //     !record.is_reserved &&
            //     record.result !== null &&
            //     record.result !== 0
            // ) {
            //     return (
            //         <CustomColumn>{`발송 실패(${record.result})`}</CustomColumn>
            //     );
            // }

            if (record.status !== null) {
                switch (record.status) {
                    case 'TODO': {
                        return <CustomColumn>{'정상 예약'}</CustomColumn>;
                    }
                    case 'DOING': {
                        return <CustomColumn>{'전송 중'}</CustomColumn>;
                    }
                    case 'DONE': {
                        return <CustomColumn>{'전송 완료'}</CustomColumn>;
                    }
                }
            }

            return <CustomColumn>{`알 수 없음`}</CustomColumn>;
        },
    },
    {
        title: '내용',
        dataIndex: 'content',
        key: 'content',
        width: 252,
        render: (_, record) => <MessageContentColumn record={record} />,
    },
];

export const sendedMessageColumns = [
    {
        title: 'No',
        dataIndex: 'key',
        key: 'key',
        width: 56,
        render: (key, record, index) => (
            <CustomColumn>{index + 1}</CustomColumn>
        ),
    },
    //   {
    //     title: "타입",
    //     dataIndex: "type",
    //     key: "type",
    //     width: 128,
    //     render: (key, record, index) => <CustomColumn>{record.TYPE}</CustomColumn>,
    //   },
    {
        title: '발신번호',
        dataIndex: 'caller',
        key: 'caller',
        width: 196,
        render: (_, record) => {
            if (record.TR_NUM) {
                return (
                    <CustomColumn>
                        {record?.TR_CALLBACK?.replace(
                            /^(\d{3})(\d{4})(\d{4})$/,
                            '$1-$2-$3',
                        )}
                    </CustomColumn>
                );
            }
            if (record.MSGKEY) {
                return (
                    <CustomColumn>
                        {record?.CALLBACK?.replace(
                            /^(\d{3})(\d{4})(\d{4})$/,
                            '$1-$2-$3',
                        )}
                    </CustomColumn>
                );
            }
            if (record.job_id) {
                return (
                    <CustomColumn>
                        {record?.callback_num?.replace(
                            /^(\d{3})(\d{4})(\d{4})$/,
                            '$1-$2-$3',
                        )}
                    </CustomColumn>
                );
            }
        },
    },
    {
        title: '수신번호',
        dataIndex: 'receiver',
        key: 'receiver',
        width: 196,
        render: (_, record, idx) => {
            if (record.TR_NUM) {
                return (
                    <CustomColumn>
                        {record?.TR_PHONE?.replace(
                            /^(\d{3})(\d{4})(\d{4})$/,
                            '$1-$2-$3',
                        )}
                    </CustomColumn>
                );
            }
            if (record.MSGKEY) {
                return (
                    <CustomColumn>
                        {record?.PHONE?.replace(
                            /^(\d{3})(\d{4})(\d{4})$/,
                            '$1-$2-$3',
                        )}
                    </CustomColumn>
                );
            }
            if (record.job_id) {
                return (
                    <CustomColumn>
                        {record?.rcpt_data?.replace(
                            /^(\d{3})(\d{4})(\d{4})$/,
                            '$1-$2-$3',
                        )}
                    </CustomColumn>
                );
            }
        },
    },
    {
        title: '날짜',
        dataIndex: 'date',
        key: 'date',
        width: 196,
        render: (_, record) => {
            // console.log('record', record);

            if (record.RSLTDATE || record.TR_RSLTDATE) {
                return (
                    <CustomColumn>
                        {record.RSLTDATE
                            ? record.RSLTDATE
                            : record.TR_RSLTDATE
                            ? record.TR_RSLTDATE
                            : null}
                    </CustomColumn>
                );
            }

            if (record.schedule_time) {
                // 발송 내역은 실제 전달 된 시간을 표시
                return (
                    <CustomColumn>
                        {moment(record.schedule_time).format(
                            'YYYY-MM-DD HH:mm:ss',
                        )}
                    </CustomColumn>
                );
            }

            // 예약 / 발송 내역이 나뉘어져 있어서 필요없는 코드
            // if (record.is_reserved) {
            //     // 예약 내역은 전달할 시간을 표시
            //     return (
            //         <CustomColumn>
            //             {moment(record.schedule_time).format(
            //                 'YYYY-MM-DD HH:mm:ss',
            //             )}
            //         </CustomColumn>
            //     );
            // } else {
            //     // 발송 내역은 실제 전달 된 시간을 표시
            //     return (
            //         <CustomColumn>
            //             {moment(record.delivery_time).format(
            //                 'YYYY-MM-DD HH:mm:ss',
            //             )}
            //         </CustomColumn>
            //     );
            // }
        },
    },
    {
        title: '결과',
        dataIndex: 'result',
        key: 'result',
        width: 132,
        render: (_, record) => {
            if (record.RSLT && record.RSLT === '0') {
                return <CustomColumn>{'성공'}</CustomColumn>;
            }

            if (record.RSLT && record.RSLT !== '0') {
                return <CustomColumn>{`실패(${record.RSLT})`}</CustomColumn>;
            }

            if (record.TR_RSLTSTAT && record.TR_RSLTSTAT === '0') {
                return <CustomColumn>{'성공'}</CustomColumn>;
            }

            if (record.TR_RSLTSTAT && record.TR_RSLTSTAT !== '0') {
                return (
                    <CustomColumn>{`실패(${record.TR_RSLTSTAT})`}</CustomColumn>
                );
            }

            if (
                // !record.is_reserved &&
                record.result !== null &&
                record.result === 0
            ) {
                return <CustomColumn>{'성공'}</CustomColumn>;
            }

            if (
                // !record.is_reserved &&
                record.result !== null &&
                record.result !== 0
            ) {
                return (
                    <CustomColumn>{`발송 실패(${record.result})`}</CustomColumn>
                );
            }

            // 발송 / 예약 내역이 나뉘어져 있어서 필요없는 코드 (기존 예약 내역 코드)
            // if (record.is_reserved && record.status !== null) {
            //     switch (record.status) {
            //         case 'TODO': {
            //             return <CustomColumn>{'정상 예약'}</CustomColumn>;
            //         }
            //         case 'DOING': {
            //             return <CustomColumn>{'전송 중'}</CustomColumn>;
            //         }
            //         case 'DONE': {
            //             return <CustomColumn>{'전송 완료'}</CustomColumn>;
            //         }
            //     }
            // }

            return <CustomColumn>{`알 수 없음`}</CustomColumn>;
        },
    },
    {
        title: '내용',
        dataIndex: 'content',
        key: 'content',
        width: 252,
        render: (_, record) => <MessageContentColumn record={record} />,
    },
    {
        title: '환불 여부',
        dataIndex: 'refund_point',
        key: 'refund_point',
        width: 100,
        render: (_, record) => {
            if (record.refund_status && record.refund_status === 'DONE') {
                return <CustomColumn>{'환불 완료'}</CustomColumn>;
            }

            if (record.refund_status && record.refund_status === 'TODO') {
                return <CustomColumn>{'환불 예정'}</CustomColumn>;
            }

            return <CustomColumn>{'-'}</CustomColumn>;
        },
    },
];

export const pushNotificationColumn = [
    {
        title: 'No',
        dataIndex: 'key',
        key: 'key',
        width: 56,
        render: (key, record, index) => (
            <CustomColumn>{index + 1}</CustomColumn>
        ),
    },
    //   {
    //     title: "타입",
    //     dataIndex: "type",
    //     key: "type",
    //     width: 128,
    //     render: (key, record, index) => <CustomColumn>{record.TYPE}</CustomColumn>,
    //   },

    {
        title: '고객명',
        dataIndex: 'to_name',
        key: 'to_name',
        width: 196,
        render: (_, record, idx) => (
            <CustomColumn>{record.to_name ? record.to_name : '-'}</CustomColumn>
        ),
    },
    {
        title: '날짜',
        dataIndex: 'date',
        key: 'date',
        width: 196,
        render: (_, record) => (
            <CustomColumn>
                {moment(record.created_dttm).format('YYYY-MM-DD HH:mm:ss')}
            </CustomColumn>
        ),
    },
    {
        title: '제목',
        dataIndex: 'title',
        key: 'title',
        width: 192,
        render: (_, record) => (
            <CustomColumn>{record.title ? record.title : '-'}</CustomColumn>
        ),
    },
    {
        title: '내용',
        dataIndex: 'content',
        key: 'content',
        width: 252,
        render: (_, record) => <MessageContentColumn record={record} />,
    },
];

// 예약 내역
export const reservedKakaoAlimColumns = (templates) => {
    const tmplMap = {};
    templates.forEach((tmp) => {
        tmplMap[tmp.tmpl_cd] = tmp.tmpl_name;
    });
    return [
        {
            title: 'No',
            dataIndex: 'key',
            key: 'key',
            width: 56,
            render: (key, record, index) => (
                <CustomColumn>{index + 1}</CustomColumn>
            ),
        },
        {
            title: '수신번호',
            dataIndex: 'receiver',
            key: 'receiver',
            width: 160,
            render: (_, record, idx) => {
                // console.log('record', record);
                if (record.rcpt_phone_number) {
                    return (
                        <CustomColumn>
                            {record?.rcpt_phone_number?.replace(
                                /^(\d{3})(\d{4})(\d{4})$/,
                                '$1-$2-$3',
                            )}
                        </CustomColumn>
                    );
                }
            },
        },
        {
            title: '예약일시',
            dataIndex: 'reserved_time',
            key: 'reserved_time',
            width: 180,
            render: (_, record) => {
                if (record.reserved_time) {
                    return (
                        <CustomColumn>
                            {moment(record.reserved_time).format(
                                'YYYY-MM-DD HH:mm:ss',
                            )}
                        </CustomColumn>
                    );
                }
            },
        },
        {
            title: '템플릿명',
            dataIndex: 'tmpl_cd',
            key: 'tmpl_cd',
            width: 252,
            render: (_, record) => {
                // 추후 고도화 된다면 수정 필요
                // 1. function_type 으로 먼저 매칭
                // 2. function_type 이 없는 경우 템플릿 코드 -> 템플릿 명으로 매칭
                if (record.tmpl_cd) {
                    return (
                        <CustomColumn>
                            {tmplMap[record.tmpl_cd] || record.tmpl_cd}
                        </CustomColumn>
                    );
                }
            },
        },
        {
            // 내용에 템플릿과 매칭 된 이미지 들어가야함
            title: '내용',
            dataIndex: 'send_msg',
            key: 'send_msg',
            width: 252,
            render: (_, record) => <MessageContentColumn record={record} />,
        },
        {
            title: '상태',
            dataIndex: 'status',
            key: 'status',
            width: 132,
            render: (_, record) => {
                if (record.status) {
                    let resultStatus = '-';
                    switch (record.status) {
                        case 'SUCCESS':
                            {
                                resultStatus = '성공';
                            }
                            break;
                        case 'SENT':
                            {
                                resultStatus = '전송 완료';
                            }
                            break;
                        case 'PROCESSING':
                            {
                                resultStatus = '전송 중';
                            }
                            break;
                        case 'WAITING':
                            {
                                resultStatus = '정상 예약';
                            }
                            break;
                        case 'UNKNOWN':
                            {
                                resultStatus = '알수 없음';
                            }
                            break;
                    }
                    return <CustomColumn>{resultStatus}</CustomColumn>;
                }
            },
        },
    ];
};
// 발송 내역
export const sendedKakaoAlimColumns = (templates) => {
    const tmplMap = {};
    const tmplFctypeMap = {};

    templates.forEach((tmp) => {
        tmplMap[tmp.tmpl_cd] = tmp.tmpl_name;
    });
    templates.forEach((tmp) => {
        tmplFctypeMap[tmp.function_type] = tmp.tmpl_name;
    });
    return [
        {
            title: 'No',
            dataIndex: 'key',
            key: 'key',
            width: 56,
            render: (key, record, index) => (
                <CustomColumn>{index + 1}</CustomColumn>
            ),
        },
        {
            title: '수신번호',
            dataIndex: 'rcpt_phone_number',
            key: 'rcpt_phone_number',
            width: 160,
            render: (_, record, idx) => {
                // console.log('record', record);
                if (record.rcpt_phone_number) {
                    return (
                        <CustomColumn>
                            {record?.rcpt_phone_number?.replace(
                                /^(\d{3})(\d{4})(\d{4})$/,
                                '$1-$2-$3',
                            )}
                        </CustomColumn>
                    );
                }
            },
        },
        {
            title: '날짜',
            dataIndex: 'created',
            key: 'created',
            width: 180,
            render: (_, record) => {
                if (record.created) {
                    return (
                        <CustomColumn>
                            {moment(record.created).format(
                                'YYYY-MM-DD HH:mm:ss',
                            )}
                        </CustomColumn>
                    );
                }
            },
        },
        {
            title: '템플릿명',
            dataIndex: 'tmpl_cd',
            key: 'tmpl_cd',
            width: 180,
            render: (_, record) => {
                // 1. function_type 으로 먼저 매칭
                // 2. function_type 이 없는 경우 템플릿 코드 -> 템플릿 명으로 매칭
                if (!record.tmpl_cd && !record.function_type) return null;

                const byFunctionType =
                    record.function_type && tmplFctypeMap[record.function_type];

                const byTmplCd =
                    tmplMap[record.tmpl_cd] ||
                    `매칭되지 않은 템플릿(${record.tmpl_cd})`;

                const label = byFunctionType || byTmplCd;

                return <CustomColumn>{label}</CustomColumn>;
            },
        },
        {
            // 이미지 매칭 필요
            title: '내용',
            dataIndex: 'send_msg',
            key: 'send_msg',
            width: 230,
            render: (_, record) => {
                if (record.send_msg) {
                    return <MessageContentColumn record={record} />;
                }
            },
        },
        {
            title: '상태',
            dataIndex: 'result',
            key: 'result',
            width: 100,
            render: (_, record) => {
                if (record.status && record.status === 'SUCCESS') {
                    return <CustomColumn>{'성공'}</CustomColumn>;
                }

                if (record.status && record.status === 'FAILED') {
                    return (
                        <CustomColumn>{`실패(${record.failure_code})`}</CustomColumn>
                    );
                }

                return <CustomColumn>{`알 수 없음`}</CustomColumn>;
            },
        },
        {
            title: '환불 여부',
            dataIndex: 'refund_status',
            key: 'refund_status',
            width: 100,
            render: (_, record) => {
                if (record.refund_status && record.refund_status === 'DONE') {
                    return <CustomColumn>{'환불 완료'}</CustomColumn>;
                }

                if (record.refund_status && record.refund_status === 'TODO') {
                    return <CustomColumn>{'환불 예정'}</CustomColumn>;
                }

                return <CustomColumn>{'-'}</CustomColumn>; // 'NONE'인 경우
            },
        },
    ];
};

const commonColumnStyle = `
font-family: "Noto Sans KR-Regular";
font-style: normal;
font-size: 14px;
line-height: 20px;
display: flex;
align-items: center;
justify-content: center;
text-align: center; `;

const CustomColumn = styled.div`
  ${commonColumnStyle}
`;
